import React from 'react';

const ShareholderRelationshipsCategory = React.lazy(() =>
  import('pages/ShareholderRelationshipCategory/ShareholderRelationshipCategory'),
);
const ShareholderRelationshipsCategoryAdd = React.lazy(() =>
  import('pages/ShareholderRelationshipCategory/ShareholderRelationshipCategoryAdd'),
);
const ShareholderRelationshipsCategoryEdit = React.lazy(() =>
  import('pages/ShareholderRelationshipCategory/ShareholderRelationshipCategoryEdit'),
);
const ShareholderRelationshipsCategoryDetail = React.lazy(() =>
  import('pages/ShareholderRelationshipCategory/ShareholderRelationshipCategoryDetail'),
);

const shareholderRelationshipsCategoryRoutes = [
  {
    path: '/shareholder-relationship-category',
    exact: true,
    name: 'Danh sách danh mục',
    function: 'SHAREHOLDER_RELATIONSHIP_CATEGORY_VIEW',
    component: ShareholderRelationshipsCategory,
  },
  {
    path: '/shareholder-relationship-category/add',
    exact: true,
    name: 'Thêm mới danh mục',
    function: 'SHAREHOLDER_RELATIONSHIP_CATEGORY_ADD',
    component: ShareholderRelationshipsCategoryAdd,
  },
  {
    path: '/shareholder-relationship-category/detail/:id',
    exact: true,
    name: 'Chi tiết danh mục',
    function: 'SHAREHOLDER_RELATIONSHIP_CATEGORY_VIEW',
    component: ShareholderRelationshipsCategoryDetail,
  },
  {
    path: '/shareholder-relationship-category/edit/:id',
    exact: true,
    name: 'Chỉnh sửa danh mục',
    function: 'SHAREHOLDER_RELATIONSHIP_CATEGORY_EDIT',
    component: ShareholderRelationshipsCategoryEdit,
  },
];

export default shareholderRelationshipsCategoryRoutes;
